export default "__VITE_ASSET__DxLQmIFA__"